module.exports = __webpack_public_path__ + "img/SSWS_DARK_Sword.c4b90e4c.png";